"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isRequesting: false,
  isProcessing: false
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "It will not put back missing race/phases - use \"Fix Parameters\" button for that");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Competitions which have slightly different divisions on each day will get slightly odd results!");
class CopyDay extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleRequest", () => {
      this.setState({
        isRequesting: !this.state.isRequesting
      });
    });
    _defineProperty(this, "_onCopyDay", () => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      this.props.initialiseStartList(this.props.competitionDay.id).then(() => this.setState(initialState));
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCopyDay,
      type: "primary",
      disabled: this.state.isProcessing
    }, "Confirm"));
    const day = (0, _occasion.default)(this.props.competitionDay.dayDate, 'dddd');
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      loading: this.state.loading,
      style: {
        marginBottom: '8px'
      }
    }, "Copy Setup"), !this.state.isRequesting ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this._onToggleRequest,
      title: 'Copy ' + day + ' Set Up'
    }, /*#__PURE__*/_react.default.createElement("p", null, "This will copy the set up for ", day, " to the other day(s) in your competition. It works best for Double Competitions where the same events and divisions are happening on both days."), _ref, _ref2));
  }

  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CopyDay, "partials", {
  CompetitionDay: {
    id: true,
    dayDate: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(CopyDay, undefined, (client, props) => ({
  initialiseStartList(competitionDayID) {
    return client.update('StartListRun.copyDayOrder', {
      competitionDayID
    });
  }
}));